/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { gettext } from "../../shared/utils/legacy";
interface DashboardSummaryInfoProperties {
  href?: string;
  title?: string;
  category: string;
  children?: React.ReactNode;
}
const DashboardSummaryInfo = ({
  href,
  title,
  category,
  children,
}: DashboardSummaryInfoProperties) => (
  <a
    href={href || `https://www.dacom.nl/nl/producten/${category}/`}
    target="_blank"
    title={title || gettext("Click for more info")}
    data-metrics_category="summary_widget"
    data-metrics_sub_category={`more_info_${category}`}
  >
    {children || gettext("Not available")}
  </a>
);
export default DashboardSummaryInfo;
